// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-container-hDO_k {
  display: flex;
  align-items: center;
}

.title-icon-tVeXJ {
  --size: 22px;
  margin-right: 20px;
}

.title-title-w5mxJ {
  font-size: 18px;
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/title/title.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n}\n\n.icon {\n  --size: 22px;\n  margin-right: 20px;\n}\n\n.title {\n  font-size: 18px;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `title-container-hDO_k`,
	"icon": `title-icon-tVeXJ`,
	"title": `title-title-w5mxJ`
};
export default ___CSS_LOADER_EXPORT___;
